export const COMMENT = 'comment'
export const SELECTED_FILES = 'selectedFiles'

export const getInitialValues = selectedFileData => {
  return {
    [COMMENT]: selectedFileData.comment || '',
    [SELECTED_FILES]: {
      [selectedFileData?.id]: true
    }
  }
}
